export default __webpack_public_path__ + "static/media/noPoster.8fdf2000.jpg";